import axios from '_u/axios'

// 积分查询
export const integralList = (body) => {
    return axios.post('api/wx/integral/statisticUserIntegral', body)
}

// 积分明细查询
export const integralDetailList = (body) => {
    return axios.post('api/wx/integral/list', body)
}

// 商品列表
export const goodsList = (body) => {
    return axios.post('api/mall/info/list', body)
}

// 商品列表
export const goodsView = (id) => {
    return axios.post('api/mall/info/view', { id })
}

// 商品列表
export const goodsAdd = (body) => {
    return axios.post('api/mall/info/add', body)
}

// 商品列表
export const goodsUpdate = (body) => {
    return axios.post('api/mall/info/update', body)
}

// 商品列表
export const goodsDelete = (id) => {
    return axios.post('api/mall/info/delete', { id })
}


// 订单列表
export const orderList = (body) => {
    return axios.post('api/mall/order/list', body)
}

// 订单列表
export const orderView = (id) => {
    return axios.post('api/mall/order/view', { id })
}

// 订单列表
export const orderAdd = (body) => {
    return axios.post('api/mall/order/add', body)
}

// 订单列表
export const orderUpdate = (body) => {
    return axios.post('api/mall/order/update', body)
}

// 订单列表
export const orderDelete = (id) => {
    return axios.post('api/mall/order/delete', { id })
}


// 营销分析列表
export const marketingList = (body) => {
    return axios.post('api/sell/statistic/projMarketing', body)
}

// 项目流量分析
export const projFlowAnalysis = (body) => {
    return axios.post('api/sell/statistic/projMarketingTimeline', body)
}
